import {FACTION_CONFIGS} from '../../../configs/factions';
import {getFactionRankIconPath} from '../../../utils/factions/getFactionRankIconPath';
import {checkIfRankSkinListed, getRankSkinId, RANK_SKIN_LEAGUES} from '../../../configs/rankSkins';
import {RANK_SKIN_DISPLAY} from '../../../utils/factions/getFactionRankSkinTitle';

/**
 * Раздел «Рейтинговые обличия» в коллекции: только сами ранговые образы —
 * обычный вид фракции показывает соседний раздел «Фракции», и здесь он лишь
 * разбавлял редкие образы.
 *
 * Порядок: сперва открытые рубиновые, за ними открытые алмазные, потом
 * открытые золотые (самое ценное — первым), дальше неоткрытые, среди которых
 * выше идут образы доступных игроку фракций — их реально добывать.
 *
 * Образ, чей новый арт еще не нарисован (алмазные и рубиновые
 * нереализованных фракций), в разделе не показывается — кроме уже открытых
 * образов (см. checkIfRankSkinListed).
 *
 * @param {Array<{id: string, isAvailable: boolean}>} factions - фракции игрока
 * @param {string[]} availableSkinIds - открытые образы
 * @returns {Array<Object>} элементы плиток по порядку показа
 */
export const buildRankSkinItems = (factions, availableSkinIds) => {
  const ownedSkinIds = new Set(availableSkinIds || []);
  const availableFactionsById = new Map((factions || []).map((faction) => [faction.id, faction]));

  // Лиги от старшей к младшей: и у каждой фракции, и среди открытых самое
  // ценное идет первым
  const leaguesDesc = [...RANK_SKIN_LEAGUES].reverse();

  const buildRankSkin = (faction, rank) => ({
    id: getRankSkinId(faction.id, rank),
    name: `${faction.name} — скин ${RANK_SKIN_DISPLAY[rank].leagueAdjectiveGenitive} лиги`,
    factionId: faction.id,
    rank,
    iconPath: getFactionRankIconPath(faction.id, rank),
    isAvailable: ownedSkinIds.has(getRankSkinId(faction.id, rank)),
    hasFaction: Boolean(availableFactionsById.get(faction.id)?.isAvailable),
  });

  const allRankSkins = FACTION_CONFIGS
    .flatMap((faction) => leaguesDesc.map((rank) => buildRankSkin(faction, rank)))
    .filter((skin) => checkIfRankSkinListed(skin.rank, skin.isAvailable, skin.factionId));

  const openedOf = (rank) => allRankSkins.filter((skin) => skin.isAvailable && skin.rank === rank);
  const locked = allRankSkins
    .filter((skin) => !skin.isAvailable)
    .sort((a, b) => {
      if (a.hasFaction === b.hasFaction) return 0;
      return a.hasFaction ? -1 : 1;
    });

  return [...leaguesDesc.flatMap(openedOf), ...locked];
};
